import { useState, useRef } from "react";
import { useToast } from "@chakra-ui/react";
import useMerchantPortalAxios, {useMerchantPortalFormData} from "../utils/axios";

const TransactionDetailsAPI = () => {
    const toast = useToast();
    const toastRef = useRef(null);
    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxios1 = useMerchantPortalFormData();
    const [transactionDetails, SetTransactionDetails] = useState([]);
    const [detailsLoading, setDetailsLoading] = useState(false);

    async function GetTransactionDetails(TransactionID) {
        setDetailsLoading(true);
        await MerchantPortalAxios.post(
            `/v1/TransactionDetails/GetTransactionDetails`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                TransactionID: TransactionID
            }
        ).then((res) => {
            SetTransactionDetails(res.data.Payload.TransactionDetails);
            setDetailsLoading(false);
        });
    }

    async function UploadTransactionDetailsFile(payload) {
        // const file = new File([payload.ReasonFile], payload.ReasonFileName);
        if (payload.ReasonFile) {
            const fileData = payload.ReasonFile.split(',')[1];
            const mimeType = payload.ReasonFile.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            const file = new File([byteArrays], payload.ReasonFileName, { type: mimeType });
            payload.ReasonFile = file;
        }
        await MerchantPortalAxios1.post(
            `/v1/TransactionDetails/UploadTransactionDetailsFile`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                TransactionID: payload.TransactionID,
                ReasonFile: payload.ReasonFile
            }
        );
            // .then((res) => {
            // if(res.data.Payload.Flag === 0){
            //     toastRef.current = toast({
            //         position: "top",
            //         title: "Success",
            //         description: `File uploaded successfully`,
            //         status: "success",
            //         duration: "5000",
            //         isClosable: "false",
            //     });
            // }
        //     else{
        //         toastRef.current = toast({
        //             position: "top",
        //             title: "Error",
        //             description: res.data.Payload.Description,
        //             status: "error",
        //             duration: "5000",
        //             isClosable: "false",
        //         });
        //     }
        //     GetTransactionDetails(payload.TransactionID);
        // }).catch((err) => {
        //     toastRef.current = toast({
        //         position: "top",
        //         title: "Error",
        //         description: err.description,
        //         status: "error",
        //         duration: "5000",
        //         isClosable: "false",
        //     });
        // });
    }

    return {
        GetTransactionDetails,
        transactionDetails,
        detailsLoading,
        UploadTransactionDetailsFile
    };
};

export default TransactionDetailsAPI;
